<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>

    <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                    <v-container>
                        <v-row class="mt-5">
                            <v-col cols="11" md="3" class="mt-n5 d-flex">
                                <v-text-field class='casilla_grey text-caption' v-model="sku" label="Sku" dense rounded readonly></v-text-field>
                                <!-- <v-text-field v-if="existe==''" class='casilla_beige text-caption' v-model="sku" label="Sku" dense rounded></v-text-field>
                                <v-text-field v-else class='casilla_grey text-caption' v-model="sku" label="Sku" dense rounded disabled></v-text-field> 
                                <v-btn @click="searchProducts()" class="mt-1 ml-2" small color="teal" dark rounded><v-icon small>search</v-icon></v-btn>-->
                                <v-btn v-if="btn_create_product!=true" @click="create_number_product()" class="mt-1 ml-2" small color="teal" dark rounded>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;crear Sku&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-btn>
                                <v-btn v-else class="mt-1 ml-2" small color="grey" dark rounded>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;crear Sku&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-btn>
                            </v-col>                            
                            <v-col cols="12" md="7" class="mt-n5">
                                <v-alert class='text-caption' v-if="existe=='si'" shaped dense text type="success">
                                    Existe !!!
                                </v-alert>
                                <v-alert class='text-caption' v-else-if="existe=='no'" shaped dense text type="warning">
                                    Nueva !!!
                                </v-alert>
                                <v-alert class='text-caption' v-else dense shaped text type="info">
                                    Selecciona Producto o Material !!!
                                </v-alert>
                            </v-col>
                            <v-col cols="12" md="2" class="mt-n5 text-end">
                                    <strong class="mt-1">Editar Producto</strong>
                                    <v-btn @click="d_products=true" class="mt-n1 ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>                                
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
                <v-container>
                    <v-row class="mt-7">
                        <v-col cols="12" md="4" class="mt-n3 d-flex">
                            <v-select class='casilla_beige  text-caption' v-model="categoria" :items="categorias" label="Categoria" item-text="categoria" item-value="id" dense rounded></v-select>
                            <v-icon @click="d_categoria=true" class="ml-2" color="indigo" large>add_circle</v-icon>
                        </v-col>
                        <v-col cols="12" md="5" class="mt-n3">
                            <v-text-field class='casilla_beige text-caption' v-model="producto" label="Producto" dense rounded></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2" class="mt-n3">
                            <v-select class='casilla_beige text-caption' v-model="medida" :items="medidas" label="Medida" dense rounded></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="mt-5">
                        <v-col cols="12" md="4" class="mt-n3">
                            <v-row class="mt-n2">
                                <v-col cols="12" md="12" class="mt-n3">
                                    <v-textarea style="background-color:beige;border:1px solid lightgray" class='text-caption' no-resize rows="4" dense rounded v-model="descripcion" label="Descripcion"></v-textarea>
                                </v-col>
                                <!-- <v-col cols="12" md="12" class="mt-n3 d-flex">
                                    <v-select class='casilla_beige  text-caption' v-model="bodega" :items="bodegas" label="Bodega" item-text="bodega" item-value="id" dense rounded></v-select>
                                    <v-icon @click="d_bodega=true" class="ml-2" color="indigo" large>add_circle</v-icon>
                                </v-col> -->
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-row class="mt-n2">
                                <v-col cols="12" md="4" class="mt-n3 d-flex">
                                    <v-select class='casilla_beige text-caption' v-model="marca" :items="marcas" item-value="id" item-text='marca' label="Marca" dense rounded></v-select>
                                    <v-icon @click="d_marca=true" class="ml-2" color="indigo" large>add_circle</v-icon>
                                    <!-- <v-text-field class='casilla_beige text-caption' v-model="marca" label="Marca" dense rounded></v-text-field> -->
                                </v-col>
                                <v-col cols="12" md="4" class="mt-n3 d-flex">
                                    <v-text-field class='casilla_beige text-caption' v-model="modelo" label="Modelo" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" class="mt-n3 d-flex">
                                    <v-text-field class='casilla_beige text-caption' v-model="serie" label="Serie" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3" class="mt-n3">
                                    <v-text-field @keypress="onlyDecimal" class='casilla_beige text-caption' v-model="peso" label="Peso (kg)" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3" class="mt-n3 d-flex">
                                    <v-text-field @keypress="onlyDecimal" class='casilla_beige text-caption' v-model="volumen" label="Volumen (cm3)" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3" class="mt-n3 d-flex">
                                    <v-text-field @keypress="onlyDecimal" class='casilla_beige text-caption' v-model="precio_detalle" label="Precio" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3" class="mt-n3">
                                    <v-text-field @keypress="onlyDecimal" class='casilla_beige text-caption' v-model="critico" label="Stock Critico" dense rounded></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-3">
                                <v-col cols="12" md="6" class="mt-n3 d-flex">
                                    <v-text-field class='casilla_beige text-caption' v-model="barra" label="Cod. Barra" dense rounded></v-text-field>
                                    <v-btn v-if="btn_generate==true" @click="createBarCode()" class="ml-2 mt-2" x-small rounded color="cyan" dark>generar codigo</v-btn>
                                    <v-btn v-else class="ml-2 mt-2" x-small rounded color="grey" dark>generar codigo</v-btn>
                                </v-col>
                                <v-col cols="12" md="3" class="mt-n3 text-end">
                                    <v-select class='casilla_beige text-caption' v-model="estado" :items="estados" label="Estado" dense rounded></v-select>
                                </v-col>
                            </v-row>
                            <v-row class="mt-3">
                                <v-col cols="11" md="4" class="mt-n3">
                                    <strong class="mt-2 ml-5 text-caption">selecciona Ficha Tecnica</strong>
                                    <v-btn class="ml-2" fab x-small color="indigo" outlined>
                                        <v-file-input id="filePDF" class="mt-0 ml-2" hide-input v-model="archivo" dense accept=".pdf"></v-file-input>
                                    </v-btn>                                
                                </v-col>
                                <v-col cols="12" md="5" class="mt-n4">
                                    <v-text-field id="name_file" class='casilla_beige text-body-2' v-model="nombre_archivo" dense disabled rounded></v-text-field>
                                </v-col>
                                 <!-- <v-col cols="6" md="2" class="mt-n2">
                                    <v-btn @click="fileUp()" class="ml-2" x-small color="indigo" outlined rounded>
                                        <v-icon class="mt-0 ml-0" small>file_upload</v-icon>
                                        subir ficha
                                    </v-btn>
                                 </v-col> -->
                                 <v-col cols="12" md="3" class="mt-n2 text-end">
                                        <v-btn @click="open_pdf()" class="ml-2" x-small color="indigo" outlined rounded>
                                            <v-icon class="mt-0 ml-0" small>visibility</v-icon>
                                            <span class="ml-1">ver ficha</span>
                                        </v-btn>                                            
                                        <!-- <a :href="rutaPDF" download target="_blank" style="text-decoration: none;">
                                            <v-btn class="ml-2" x-small color="indigo" outlined rounded>
                                                <v-icon class="mt-0 ml-0" small>visibility</v-icon>
                                                <span class="ml-1">ver ficha</span>
                                            </v-btn>                                            
                                        </a> -->
                                 </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-row>
            <div class="mt-2">
                <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                    <v-container>
                        <h5>Imagenes</h5>
                        <img src="@/assets/no_image.jpg" id="imgDefault" width="0" height="0"/>
                        <div class="mt-2">
                            <v-row>
                                <v-col cols="12" md="2" class="mt-n5 text-center">
                                    <form method="post" action="#" enctype="multipart/form-data">
                                        <div>
                                            <v-icon @click="deleteImage(1)" class="mr-2" color="red">cancel</v-icon>
                                            <label for="file1"><v-icon color="green">add_circle</v-icon></label>
                                            <v-icon @click="openViewImage(1)" class="ml-2" color="blue">visibility</v-icon>
                                            <br>
                                            <img :src="imgDefault" id="img1"/>
                                            <input type="file" name="file1" id="file1" accept="image/*" /><br/>
                                        </div>
                                    </form>
                                </v-col>
                                <v-col cols="12" md="2" class="mt-n5 text-center">
                                    <form method="post" action="#" enctype="multipart/form-data">
                                        <div>
                                            <v-icon @click="deleteImage(2)" class="mr-2" color="red">cancel</v-icon>
                                            <label for="file2"><v-icon color="green">add_circle</v-icon></label>
                                            <v-icon @click="openViewImage(2)" class="ml-2" color="blue">visibility</v-icon>
                                            <br>
                                            <img :src="imgDefault" id="img2"/>
                                            <input type="file" name="file2" id="file2" accept="image/*" /><br/>
                                        </div>
                                    </form>
                                </v-col>
                                <v-col cols="12" md="2" class="mt-n5 text-center">
                                    <form method="post" action="#" enctype="multipart/form-data">
                                        <div>
                                            <v-icon @click="deleteImage(3)" class="mr-2" color="red">cancel</v-icon>
                                            <label for="file3"><v-icon color="green">add_circle</v-icon></label>
                                            <v-icon @click="openViewImage(3)" class="ml-2" color="blue">visibility</v-icon>
                                            <br>
                                            <img :src="imgDefault" id="img3"/>
                                            <input type="file" name="file3" id="file3" accept="image/*" /><br/>
                                        </div>
                                    </form>
                                </v-col>
                                <v-col cols="12" md="2" class="mt-n5 text-center">
                                    <form method="post" action="#" enctype="multipart/form-data">
                                        <div>
                                            <v-icon @click="deleteImage(4)" class="mr-2" color="red">cancel</v-icon>
                                            <label for="file4"><v-icon color="green">add_circle</v-icon></label>
                                            <v-icon @click="openViewImage(4)" class="ml-2" color="blue">visibility</v-icon>
                                            <br>
                                            <img :src="imgDefault" id="img4"/>
                                            <input type="file" name="file4" id="file4" accept="image/*" /><br/>
                                        </div>
                                    </form>
                                </v-col>
                                <v-col cols="12" md="2" class="mt-n5 text-center">
                                    <form method="post" action="#" enctype="multipart/form-data">
                                        <div>
                                            <v-icon @click="deleteImage(5)" class="mr-2" color="red">cancel</v-icon>
                                            <label for="file5"><v-icon color="green">add_circle</v-icon></label>
                                            <v-icon @click="openViewImage(5)" class="ml-2" color="blue">visibility</v-icon>
                                            <br>
                                            <img :src="imgDefault" id="img5"/>
                                            <input type="file" name="file5" id="file5" accept="image/*" /><br/>
                                        </div>
                                    </form>
                                </v-col>
                                <v-col cols="12" md="2" class="mt-n5 text-center">
                                    <form method="post" action="#" enctype="multipart/form-data">
                                        <div>
                                            <v-icon @click="deleteImage(6)" class="mr-2" color="red">cancel</v-icon>
                                            <label for="file6"><v-icon color="green">add_circle</v-icon></label>
                                            <v-icon @click="openViewImage(6)" class="ml-2" color="blue">visibility</v-icon>
                                            <br>
                                            <img :src="imgDefault" id="img6"/>
                                            <input type="file" name="file6" id="file6" accept="image/*" /><br/>
                                        </div>
                                    </form>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </v-sheet>
            </div>
            <!-- <v-row class="mt-7">
                <v-col cols="12" md="3" class="mt-n5">
                    <v-radio-group class="mt-2" v-model="tipo" row>
                        <v-radio label="Producto" color="success" value="producto"></v-radio>
                        <v-radio label="Material" color="success" value="material"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row> -->
            <v-container>
                <v-row>
                    <v-col cols="12" md="4"></v-col>
                    <v-col cols="12" md="2">
                        <v-btn @click="clsInput()" color="teal" rounded dark small block>Limpiar</v-btn>
                    </v-col>
                    <v-col cols="12" md="2">
                        <div v-if="existe!='si'">
                            <v-btn v-if="btn_grabado!=true" @click="goSave()" color="teal" rounded dark small block>Grabar</v-btn>
                            <v-btn v-else color="grey" rounded dark small block>Grabar</v-btn>
                        </div>
                        <div v-else>
                            <v-btn v-if="btn_grabado!=true" @click="goSave()" color="teal" rounded dark small block>Actualizar</v-btn>
                            <v-btn v-else color="grey" rounded dark small block>Actualizar</v-btn>
                        </div>
                    </v-col>
                    <v-col cols="12" md="4"></v-col>
                </v-row>
            </v-container>
        </v-container>

        <v-dialog v-model="d_code" persistent max-width="400">
            <v-card color="#fff" rounded="xl">
                <v-card-title>
                    <v-icon @click="closeCodeBar()">close</v-icon>
                </v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <div v-if="generateBar==false">
                                <v-progress-circular indeterminate color="red"></v-progress-circular>
                            </div>
                            <img id="barcodeImg" />
                             <!-- <v-img id="barcodeImg" max-height="450" max-width="459"></v-img> -->
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="d_image" persistent max-width="500">
            <v-card color="#fff" rounded="xl">
                <v-card-title>
                    <v-icon @click="closeViewImage()">close</v-icon>
                </v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <div v-if="generateImg==false">
                                <v-progress-circular indeterminate color="red"></v-progress-circular>
                            </div>
                            <!-- <img id="Img" width="450" height="450" style="border:0px;"/> -->
                            <v-img :src="imgSrc" max-height="450" max-width="459"></v-img>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- lista de productos -->
        <v-dialog v-model="d_products" transition="dialog-bottom-transition" max-width="80%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_products=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        <strong class="ml-2 text-body-2">Productos</strong>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="products_search" label="Buscar Producto" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleProducts" dense dark height="400px" fixed-header
                    :search="products_search" :headers="products_titulo" :items="products_lista" 
                    :page.sync="products_page" :items-per-page="products_itemsPerPage"  
                    @page-count="products_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                    <template v-slot:item.codigo="{ item }">
                        <v-chip small>
                            {{ item.codigo }}
                        </v-chip>
                    </template>
                </v-data-table>
                <v-pagination v-model="products_page" :length="products_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- categorias -->
        <v-dialog v-model="d_categoria" transition="dialog-bottom-transition" max-width="450">
             <v-card>
                <v-card-title>
                    Crear Categoria
                <v-spacer></v-spacer>
                    <v-icon @click="d_categoria=false" color="error">close</v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row class="mt-5">
                        <v-col cols="1" md="2"></v-col>
                        <v-col cols="10" md="8">
                            <v-text-field label="Nueva Categoria" class='casilla_beige text-body-2' v-model="nueva_categoria" dense rounded></v-text-field>
                        </v-col>
                        <v-col cols="1" md="2"></v-col>
                        <v-col cols="12">
                            <v-btn @click="add_category()" small color="teal" block dark rounded>Agregar Categoria</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider class="mt-5 mb-2"></v-divider>
                    <h4>Mis Categorias</h4>
                    <div class="scroller">
                        <v-simple-table fixed-header dense>
                            <thead>
                                <tr>
                                    <th id="back" class="text-center">Id</th>
                                    <th id="back" class="text-start">Categoria</th>
                                    <th id="back">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in categorias" :key="item.id">
                                    <td class="text-center">
                                        <span class="text-caption">{{ item.id }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.categoria }}</span>
                                    </td>
                                    <td class="text-center">
                                        <v-icon v-if="parseInt(item.id)!=1" @click="verifyCategory(item)" color="red" small>delete</v-icon>
                                        <v-icon v-else color="grey" small>do_not_disturb</v-icon>
                                    </td>
                                    <td class="text-center">
                                        <v-btn v-if="parseInt(item.id)!=1" @click="open_edit_categoria(item)" icon outlined x-small color="cyan"><v-icon x-small color="cyan">edit</v-icon></v-btn>                                        
                                        <v-icon v-else color="grey" small>do_not_disturb</v-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-card-text>
             </v-card>
        </v-dialog>

        <!-- editar categoria -->
        <v-dialog v-model="d_edit_categoria" transition="dialog-bottom-transition" max-width="300">
             <v-card>
                <v-card-text>
                    <v-row class="mt-0">
                        <v-col cols="8" md="8">
                            <h5>CATEGORIA EDITADA</h5>
                        </v-col>
                        <v-col cols="4" md="4" class="text-end">
                            <v-icon @click="d_edit_categoria=false" color="error">close</v-icon>
                        </v-col>
                    </v-row>
                    <v-row class="mt-0">
                        <v-col cols="10" md="12">
                            <v-text-field class='casilla_beige text-body-2' v-model="edit_categoria" dense rounded clearable></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-0">
                        <v-col cols="12" md="12" class="text-end">
                            <v-btn @click="update_category()" small color="teal" dark rounded>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OK&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
             </v-card>
        </v-dialog>

        <!-- marcas -->
        <v-dialog v-model="d_marca" transition="dialog-bottom-transition" max-width="450">
             <v-card>
                <v-card-title>
                    Crear Marca
                <v-spacer></v-spacer>
                    <v-icon @click="d_marca=false" color="error">close</v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row class="mt-5">
                        <v-col cols="1" md="2"></v-col>
                        <v-col cols="10" md="8">
                            <v-text-field label="Nueva Marca" class='casilla_beige text-body-2' v-model="nueva_marca" dense rounded></v-text-field>
                        </v-col>
                        <v-col cols="1" md="2"></v-col>
                        <v-col cols="12">
                            <v-btn @click="add_brand()" small color="teal" block dark rounded>Agregar Marca</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider class="mt-5 mb-2"></v-divider>
                    <h4>Mis Marcas</h4>
                    <div class="scroller">
                        <v-simple-table fixed-header dense>
                            <thead>
                                <tr>
                                    <th id="back" class="text-center">Id</th>
                                    <th id="back" class="text-start">Marca</th>
                                    <th id="back">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in marcas" :key="item.id">
                                    <td class="text-center">
                                        <span class="text-caption">{{ item.id }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.marca }}</span>
                                    </td>
                                    <td class="text-center">
                                        <v-icon v-if="parseInt(item.id)!=0" @click="verifyBrand(item)" color="red" small>delete</v-icon>
                                        <v-icon v-else color="grey" small>do_not_disturb</v-icon>
                                    </td>
                                    <td class="text-center">
                                        <v-btn v-if="parseInt(item.id)!=0" @click="open_edit_marca(item)" icon outlined x-small color="cyan"><v-icon x-small color="cyan">edit</v-icon></v-btn>                                        
                                        <v-icon v-else color="grey" small>do_not_disturb</v-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-card-text>
             </v-card>
        </v-dialog>

        <!-- editar marcas -->
        <v-dialog v-model="d_edit_marca" transition="dialog-bottom-transition" max-width="300">
             <v-card>
                <v-card-text>
                    <v-row class="mt-0">
                        <v-col cols="8" md="8">
                            <h5>MARCA EDITADA</h5>
                        </v-col>
                        <v-col cols="4" md="4" class="text-end">
                            <v-icon @click="d_edit_marca=false" color="error">close</v-icon>
                        </v-col>
                    </v-row>
                    <v-row class="mt-0">
                        <v-col cols="10" md="12">
                            <v-text-field class='casilla_beige text-body-2' v-model="edit_marca" dense rounded clearable></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-0">
                        <v-col cols="12" md="12" class="text-end">
                            <v-btn @click="update_brand()" small color="teal" dark rounded>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OK&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
             </v-card>
        </v-dialog>

        <!-- bodegas -->
        <v-dialog v-model="d_bodega" transition="dialog-bottom-transition" max-width="450">
             <v-card>
                <v-card-title>
                    Crear Bodega
                <v-spacer></v-spacer>
                    <v-icon @click="d_bodega=false" color="error">close</v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row class="mt-5">
                        <v-col cols="1" md="2"></v-col>
                        <v-col cols="10" md="8">
                            <v-text-field label="Nueva Bodega" class='casilla_beige text-body-2' v-model="nueva_bodega" dense rounded></v-text-field>
                        </v-col>
                        <v-col cols="1" md="2"></v-col>
                        <v-col cols="12">
                            <v-btn @click="add_bodega()" small color="teal" block dark rounded>Agregar Bodega</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider class="mt-5 mb-2"></v-divider>
                    <h4>Mis Bodegas</h4>
                    <div class="scroller">
                        <v-simple-table fixed-header dense>
                            <thead>
                                <tr>
                                    <th id="back" class="text-center">Id</th>
                                    <th id="back" class="text-start">Bodega</th>
                                    <th id="back">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in bodegas" :key="item.id">
                                    <td class="text-center">
                                        <span class="text-caption">{{ item.id }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.bodega }}</span>
                                    </td>
                                    <td class="text-center">
                                        <v-icon @click="verifyBodega(item)" color="red" small>delete</v-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-card-text>
             </v-card>
        </v-dialog>

        <v-dialog v-model="d_pdf" persistent>
            <v-card>
                <v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="d_pdf=false" color="red" small dark><v-icon small>close</v-icon>Close</v-btn>
                </v-card-title>
                <iframe :src="rutaPDF" width="100%" height="600px" type="application/pdf"></iframe>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
form img{
  width: 150px;
  height: 150px;
  border-radius: 5%;
  border: 1px solid lightgray;
}
form div:first-child{
  align-items: center;
}
form div:first-child input{
  display: none;
}
form div:first-child label{
  /* background: #1F5F74;
  color: white; 
    border-radius: 3px; 
  padding: 6px 20px;*/
  cursor: pointer;
}
form input{
  padding: 8px 20px;
  border: 1px solid #AAA;
  border-radius: 3px;
}
.text-size >>> td {
    font-size: 9pt !important;
    height: 30px !important;
    /* background-color: lightyellow; */
}
.col-color >>> th {
    /* background-color: lightgrey; */
    background-color: lightblue;
}
.casilla_beige {
    background-color: beige; 
    height: 30px;
    border: 1px solid lightgray;
}
.casilla_grey {
    background-color: lightgray ; 
    height: 30px;
    border: 1px solid lightgray;
}
.casilla_table {
    background-color: beige; 
    height: 25px;
    border: 1px solid lightgray;
}
.scroller {
  height: 18em;
  line-height: 1em;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  /*border: 1px solid lightgray;*/
}
</style>
<script>
import axios from "axios";
import JsBarcode from "jsbarcode";
export default {
  name: 'Productos',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,
    snack:false,
    color_snack:'',
    mensaje:'',
    categorias:[],
    medidas:['UN','KG'],
    estados:['V','N'],

    existe:'',
    id_producto:0,
    tipo:'producto',
    sku:'',
    producto:'',
    descripcion:'',
    categoria:'',
    modelo:'',
    serie:'',
    variante:'',
    medida:'',
    peso:0,
    volumen:0,
    barra:'',
    precio_oferta:'0',
    precio_detalle:'0',
    precio_mayor:'0',
    estado:'',
    filled:true,
    disabled:true,
    btn_grabado:false,
    bloqueo:null,
    loading:false,

    d_code:false,
    generateBar:false,
    btn_generate:false,

    d_image:false,
    generateImg:false,

    imgSrc:'',
    imgDefault:'',
    d_products:false,
    products_titulo: [
      { text: 'Sku', align: 'start', sortable: true, value: 'codigo' },
      { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
      { text: 'Marca', align: 'start', sortable: true, value: 'txt_marca' },
      { text: 'Modelo', align: 'start', sortable: true, value: 'modelo' },
      { text: 'Serie', align: 'start', sortable: true, value: 'serie' },
    ],
    products_lista: [],
    products_page: 1,
    products_pageCount: 0,
    products_itemsPerPage: 1000000,
    products_search:'',

    d_categoria:false,
    nueva_categoria:'',

    archivo:'',
    nombre_archivo:'',
    rutaPDF:'',

    critico:'0',
    bodega:0,
    bodegas:[],
    d_bodega:false,
    nueva_bodega:'',
    d_pdf:false,

    d_marca:false,
    marcas:[],
    nueva_marca:'',
    marca:null,
    
    d_edit_marca:false,
    edit_marca:'',
    id_edit:0,

    d_edit_categoria:false,
    edit_categoria:'',
    id_categoria:0,
    number_product:'',
    btn_create_product:false,

  }),
  async mounted(){
    this.loading=true;
    this.user=localStorage.getItem('dops_myuser');
    this.apikey=localStorage.getItem('dops_apiKey');
    this.contrato=localStorage.getItem('dops_mycontrato');
    this.imgDefault=document.getElementById( 'imgDefault' ).src;
    //archivo PDF
    const inputPDF = document.getElementById('filePDF');
    inputPDF.addEventListener( 'change', e => {
        const myPDF = e;
        const myNamePDF = myPDF.target.files[0].name;
        document.getElementById('name_file').value = myNamePDF;
    });
    //listener de imagenes 1
    const file1 = document.getElementById( 'file1' );
    const img1 = document.getElementById( 'img1' )
    file1.addEventListener( 'change', e => {
        img1.src = '' ;
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img1.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);                       
        }else{
            img1.src = '';
        }        
    });
    //listener de imagenes 2
    const file2 = document.getElementById( 'file2' );
    const img2 = document.getElementById( 'img2' );
    file2.addEventListener( 'change', e => {
        img2.src = '';
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img2.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);                       
        }else{
            img2.src = '';
        }        
    });
    //listener de imagenes 3
    const file3 = document.getElementById( 'file3' );
    const img3 = document.getElementById( 'img3' );
    file3.addEventListener( 'change', e => {
        img3.src = '';
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img3.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);                       
        }else{
            img3.src = '';
        }        
    });
    //listener de imagenes 4
    const file4 = document.getElementById( 'file4' );
    const img4 = document.getElementById( 'img4' );
    file4.addEventListener( 'change', e => {
        img4.src = '';
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img4.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);                       
        }else{
            img4.src = '';
        }        
    });
    //listener de imagenes 5
    const file5 = document.getElementById( 'file5' );
    const img5 = document.getElementById( 'img5' );
    file5.addEventListener( 'change', e => {
        img5.src = '';
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img5.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);                       
        }else{
            img5.src = '';
        }        
    });
    //listener de imagenes 6
    const file6 = document.getElementById( 'file6' );
    const img6 = document.getElementById( 'img6' );
    file6.addEventListener( 'change', e => {
        img6.src = '';
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img6.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);                       
        }else{
            img6.src = '';
        }        
    });
    this.bloqueo = await this.myPermiso(3);
    if(parseInt(this.bloqueo)!=0){
        await this.serachCategory();
        await this.searchMarcas();
        await this.searchProductList()
        await this.searchBodegas();
    }
    this.loading=false;
  },
  methods:{
    async create_number_product(){
        try {
            const timestamp = Date.now();
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                clave: timestamp
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/number/product/',params,{headers});
            const datos = res.data;
            console.log(datos);
            if(datos[0].existe=='si'){
                this.btn_create_product=true;
                this.number_product=('000000' + datos[0].id).slice(-6);
                console.log(this.number_product);
                this.sku = this.number_product;
                await this.searchProducts();
            }
        } catch (error) {
            console.log(error)
        }
    },
    async createBarCode(){
        if(this.sku!='' && this.sku!= null){
            this.d_code=true;
            const newCode = 'DOSP' + this.sku;
            setTimeout(() => {
                JsBarcode('#barcodeImg', newCode, {
                    //format: 'EAN13 ',
                    lineColor: '#000',
                    width: 1.9,
                    height: 50,
                    displayValue: true
                });
                this.barra = newCode;
                this.generateBar=true;
            }, 2000);
        } else {
            this.color_snack='error';
            this.mensaje='Ingrese Sku del producto';
            this.snack=true
        }
    },
    closeCodeBar(){
        document.getElementById( 'barcodeImg' ).src = '';
        this.d_code=false;
        this.generateBar=false;
    },
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async serachCategory(){
        this.categorias=[];
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                categoria : 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/category/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.categorias=datos
            }            
        } catch (error) {
            console.log(error)
        }
    },
    async add_category(){
        this.loading=true;
        try {
            if(this.nueva_categoria!='' && this.nueva_categoria!=null){
                //validar que no se repita
                const validaCategoria = this.categorias.filter(res => res.categoria == this.nueva_categoria);
                if(validaCategoria.length!=0){
                    this.color_snack='error';
                    this.mensaje='La categoria ya existe';
                    this.snack=true
                } else {
                    const headers = {
                        'Content-Type' : 'application/json',
                        'Authorization' : 'Token ' + this.apikey
                    };
                    const params = {
                        contrato : this.contrato,
                        user :  this.user,
                        categoria : this.nueva_categoria
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/category/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        await this.serachCategory();
                        if(this.categorias.length!=0){
                            const dataCategoria = this.categorias.filter(res => res.categoria == this.nueva_categoria);
                            if(dataCategoria.length!=0){
                                this.categoria = dataCategoria[0].id
                            }
                        }
                        this.d_categoria=false;
                        this.nueva_categoria='';
                    }
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese nueva categoria';
                this.snack=true
            }
        } catch (error) {
            console.log(error)
        }
        this.loading=false;
    },
    async verifyCategory(item){
        const found = this.products_lista.filter(res => parseInt(res.categoria) == parseInt(item.id));
        if(found.length!=0){
            this.color_snack='error';
            this.mensaje='Categoria asignada a productos';
            this.snack=true
        } else {
            await this.deleteCategory(item)
        }
    },
    async deleteCategory(item){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                categoria : item.id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/delete/category/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.loading=true;
                await this.serachCategory();
                this.loading=false;
                this.color_snack='success';
                this.mensaje='Categoria eliminada';
                this.snack=true
            }            
        } catch (error) {
            console.log(error)
        }
    },


    async add_brand(){
        this.loading=true;
        try {
            if(this.nueva_marca!='' && this.nueva_marca!=null){
                //validar que no se repita
                const validaMarca = this.marcas.filter(res => res.marca == this.nueva_marca);
                if(validaMarca.length!=0){
                    this.color_snack='error';
                    this.mensaje='La Marca ya existe';
                    this.snack=true
                } else {
                    const headers = {
                        'Content-Type' : 'application/json',
                        'Authorization' : 'Token ' + this.apikey
                    };
                    const params = {
                        contrato : this.contrato,
                        user :  this.user,
                        marca : this.nueva_marca.toUpperCase()
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/brands/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        await this.searchMarcas();
                        if(this.marcas.length!=0){
                            const dataMarca = this.marcas.filter(res => res.marca == this.nueva_marca);
                            if(dataMarca.length!=0){
                                this.marca = dataMarca[0].id
                            }
                        }
                        this.d_marca=false;
                        this.nueva_marca='';
                    }
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese nueva marca';
                this.snack=true
            }
        } catch (error) {
            console.log(error)
        }
        this.loading=false;
    },
    async verifyBrand(item){
        const found = this.products_lista.filter(res => parseInt(res.marca) == parseInt(item.id));
        if(found.length!=0){
            this.color_snack='error';
            this.mensaje='Marca asignada a productos';
            this.snack=true
        } else {
            await this.deleteBrand(item)
        }
    },
    async deleteBrand(item){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                marca : item.id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/delete/brands/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.loading=true;
                await this.searchMarcas();
                this.loading=false;
                this.color_snack='success';
                this.mensaje='Marca eliminada';
                this.snack=true
            }            
        } catch (error) {
            console.log(error)
        }
    },
    async searchBodegas(){
        this.bodegas=[];
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                bodega : 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/bodegas/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.bodegas=datos
            }            
        } catch (error) {
            console.log(error)
        }
    },
    async add_bodega(){
        this.loading=true;
        try {
            if(this.nueva_bodega!='' && this.nueva_bodega!=null){
                //validar que no se repita
                const validaBodega = this.bodegas.filter(res => res.bodega == this.nueva_bodega);
                if(validaBodega.length!=0){
                    this.color_snack='error';
                    this.mensaje='La bodega ya existe';
                    this.snack=true
                } else {
                    const headers = {
                        'Content-Type' : 'application/json',
                        'Authorization' : 'Token ' + this.apikey
                    };
                    const params = {
                        contrato : this.contrato,
                        user :  this.user,
                        bodega : this.nueva_bodega
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/bodega/',params,{headers});
                    const datos = res.data;
                    console.log('datos',datos);
                    if(datos[0].existe=='si'){
                        await this.searchBodegas();
                        if(this.bodegas.length!=0){
                            const dataBodega = this.bodegas.filter(res => res.bodega == this.nueva_bodega);
                            if(dataBodega.length!=0){
                                this.bodega = dataBodega[0].id
                            }
                        }
                        this.d_bodega=false
                    }
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese nueva bodega';
                this.snack=true
            }
        } catch (error) {
            console.log(error)
        }
        this.loading=false;
    },
    async verifyBodega(item){
        const found = this.products_lista.filter(res => parseInt(res.bodega) == parseInt(item.id));
        if(found.length!=0){
            this.color_snack='error';
            this.mensaje='Bodega asignada a productos';
            this.snack=true
        } else {
            await this.deleteBodega(item)
        }
    },
    async deleteBodega(item){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                bodega : item.id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/bodega/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.loading=true;
                await this.searchBodegas();
                this.loading=false;
                this.color_snack='success';
                this.mensaje='Bodega eliminada';
                this.snack=true
            }            
        } catch (error) {
            console.log(error)
        }
    },
    async searchProductList(){
        this.products_lista=[];
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                sku : 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/create/products/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.products_lista=datos
            }            
        } catch (error) {
            console.log(error)
        }
    },
    async handleProducts(item){
        this.loading=true;
        this.clsInput();
        this.btn_create_product=true;
        if(item.estado!='X'){
            this.existe="si";
            this.id_producto = item.ID;
            this.tipo = item.tipo
            this.sku = item.codigo
            this.producto = item.producto
            this.descripcion = item.descripcion
            this.categoria = item.categoria
            this.marca = item.marca
            this.modelo = item.modelo
            this.serie = item.serie
            this.medida = item.medida
            this.peso = item.peso
            this.volumen = item.volumen
            this.barra = item.barra
            this.precio_detalle = item.precio_detalle
            this.precio_oferta = item.precio_oferta
            this.precio_mayor = item.precio_mayor
            this.estado = item.estado
            this.nombre_archivo= item.archivo
            this.rutaPDF=item.ficha
            this.critico = item.critico
            this.bodega = item.bodega
            this.btn_generate = true
            //limpiar imagenes
            document.getElementById( 'img1' ).src = this.imgDefault;
            document.getElementById( 'img2' ).src = this.imgDefault;
            document.getElementById( 'img3' ).src = this.imgDefault;
            document.getElementById( 'img4' ).src = this.imgDefault;
            document.getElementById( 'img5' ).src = this.imgDefault;
            document.getElementById( 'img6' ).src = this.imgDefault;
            //mostrar imagenes
            this.searchImages(item.codigo)
        } else {            
            this.number_product=('000000' + item.codigo).slice(-6);
            this.sku = this.number_product;
            await this.searchProducts()
        }
        this.d_products = false;
        this.loading=false;
    },
    async searchImages(code){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                sku : code
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/images/products/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                const element = datos[0];
                if(element.img1!=''){ 
                    document.getElementById( 'img1' ).src = element.img1;
                } else {
                    document.getElementById( 'img1' ).src = this.imgDefault;
                }
                if(element.img2!=''){ 
                    document.getElementById( 'img2' ).src = element.img2;
                } else {
                    document.getElementById( 'img2' ).src = this.imgDefault;
                }
                if(element.img3!=''){ 
                    document.getElementById( 'img3' ).src = element.img3;
                } else {
                    document.getElementById( 'img3' ).src = this.imgDefault;
                }
                if(element.img4!=''){ 
                    document.getElementById( 'img4' ).src = element.img4;
                } else {
                    document.getElementById( 'img4' ).src = this.imgDefault;
                }
                if(element.img5!=''){ 
                    document.getElementById( 'img5' ).src = element.img5;
                } else {
                    document.getElementById( 'img5' ).src = this.imgDefault;
                }
                if(element.img6!=''){ 
                    document.getElementById( 'img6' ).src = element.img6;
                } else {
                    document.getElementById( 'img6' ).src = this.imgDefault;
                }
            }            
        } catch (error) {
            console.log(error)
        }
    }, 
    async clsInput(){
        this.existe='';
        this.tipo='producto';
        this.sku='';
        this.producto='';
        this.descripcion='';
        this.categoria='';
        this.marca='';
        this.modelo='';
        this.serie='';
        this.variante='';
        this.medida='';
        this.peso=0;
        this.volumen=0;
        this.barra='';
        this.precio_oferta='0';
        this.precio_detalle='0';
        this.precio_mayor='0';
        this.estado='';
        document.getElementById( 'img1' ).src = this.imgDefault;
        document.getElementById( 'img2' ).src = this.imgDefault;
        document.getElementById( 'img3' ).src = this.imgDefault;
        document.getElementById( 'img4' ).src = this.imgDefault;
        document.getElementById( 'img5' ).src = this.imgDefault;
        document.getElementById( 'img6' ).src = this.imgDefault;
        this.filled=true;
        this.disabled=true;
        this.btn_grabado=false;
        this.generateBar=false;
        //document.getElementById( 'barcodeImg' ).src = '';
        this.btn_generate=false;
        //document.getElementById( 'Img' ).src = '';
        this.generateImg=false;
        this.archivo='';
        document.getElementById( 'name_file' ).value = '';
        this.rutaPDF='';
        this.nombre_archivo='';
        this.critico='0';
        this.bodega=0;
        this.nueva_bodega='';
        this.nueva_marca='';
        this.marca=null;
        this.edit_marca='';
        this.number_product='';
        this.btn_create_product=false;
    },
    async searchMarcas(){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/brands/',params,{headers});
            const datos = res.data;
            let array1 = [{ id: 0, marca: 'SIN MARCA' }];
            let array2 = [];
            if(datos[0].existe=='si'){
                array2 = datos;
            };
            this.marcas = array1.concat(array2);
        } catch (error) {
            console.log(error);
        }
    },
    async searchProducts(){
        if(this.sku!='all' && this.sku!='' && this.sku!=null){
            this.loading=true;
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    contrato : this.contrato,
                    user :  this.user,
                    sku :  this.sku
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/products/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    const element = datos[0];
                    this.id_producto = element.ID;
                    this.tipo = element.tipo
                    this.sku = element.codigo
                    this.producto = element.producto
                    this.descripcion = element.descripcion
                    this.categoria = element.categoria
                    this.marca = element.marca
                    this.modelo = element.modelo
                    this.serie = element.serie
                    this.medida = element.medida
                    this.peso = element.peso
                    this.volumen = element.volumen
                    this.barra = element.barra
                    this.precio_detalle = element.precio_detalle
                    this.precio_oferta = element.precio_oferta
                    this.precio_mayor = element.precio_mayor
                    this.estado = element.estado
                    this.rutaPDF = element.ficha
                    this.nombre_archivo = element.archivo
                    this.critico = element.critico
                    this.bodega = element.bodega
                    await this.searchImages(element.codigo);
                    this.existe='si';
                    this.filled=false;
                    this.disabled=false;
                    this.btn_generate=true;
                } else {
                    if(datos[0].existe=='no'){
                        this.existe='no';
                        this.filled=false;
                        this.disabled=false;
                        this.btn_generate=true;
                    } else {
                        this.color_snack='error';
                        this.mensaje='Inconsistencia en los datos, informar a soporte';
                        this.snack=true
                        this.btn_generate=false;
                    }
                }
            } catch (error) {
                console.log(error);
                this.color_snack='error';
                this.mensaje='Algo salio mal, informar a soporte';
                this.snack=true
            }
            this.loading=false;
        } else {
            console.log(error);
            this.color_snack='error';
            this.mensaje='Sku ingresado no existe';
            this.snack=true            
        }
    },
    async goSave(){
        this.loading=true;
        this.btn_grabado=true;
        if(this.existe=="no"){ await this.saveProduct() };
        if(this.existe=="si"){ await this.updateProduct() };
        this.loading=false;
    },
    async saveProduct(){
        try {
            //obtener las fotos
            let fotos=['','','','','','']
            fotos[0]=document.getElementById( 'img1' ).src;
            fotos[1]=document.getElementById( 'img2' ).src;
            fotos[2]=document.getElementById( 'img3' ).src;
            fotos[3]=document.getElementById( 'img4' ).src;
            fotos[4]=document.getElementById( 'img5' ).src;
            fotos[5]=document.getElementById( 'img6' ).src;
            //obtener y subir la ficha
            if (this.archivo!=''){
                let InstFormData = new FormData();
                InstFormData.append('archivo' , this.archivo);
                InstFormData.append('contrato' , this.contrato);
                const response= await axios.post(process.env.VUE_APP_URL + '/api/v1/server/FileUp/', InstFormData , {headers : {'content-type': 'multipart/form-data'}});
                if (response.data=='ok'){
                    this.nombre_archivo = this.archivo.name;
                    this.rutaPDF = process.env.VUE_APP_URL + '/images/'+ this.contrato + '/' + this.archivo.name;
                }
            }
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user: this.user,
                tipo : this.tipo,
                codigo : this.sku,
                producto : this.producto,
                descripcion : this.descripcion,
                categoria : this.categoria,
                marca : this.marca,
                modelo: this.modelo,
                serie : this.serie,
                medida : this.medida,
                peso : this.peso,
                volumen : this.volumen,
                barra : this.barra,
                precio_oferta : this.precio_oferta,
                precio_detalle : this.precio_detalle,
                precio_mayor : this.precio_mayor,
                estado : this.estado,
                ficha: this.rutaPDF,
                archivo: this.nombre_archivo,
                bodega: this.bodega,
                critico: this.critico
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/product/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                //grabamos el codigo de la foto
                const params1 = {
                    contrato : this.contrato,
                    user: this.user,
                    codigo: this.sku,
                };
                const res1 = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/code/photo/',params1,{headers});
                const datos1 = res1.data;
                if(datos1[0].existe=='si'){
                    //update de las fotos
                    for (let index = 0; index < fotos.length; index++) {
                        let myFoto = fotos[index];
                        if(myFoto==this.imgDefault){ myFoto='' };
                        const params2 = {
                            contrato : this.contrato,
                            user: this.user,
                            id: index,
                            codigo: this.sku,
                            foto: myFoto,
                        };
                        const res2 = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/photo/',params2,{headers});
                        console.log('resultado', res2.data)
                    }
                }
                this.color_snack='success';
                this.mensaje='Producto grabado con exito';
                this.snack=true;
                await this.searchProductList();
                await this.clsInput();
            } else {
                this.color_snack='error';
                this.mensaje='No es posible grabar el Producto';
                this.snack=true
            }
        } catch (error) {
            console.log(error)
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
    },
    async updateProduct(){
        try {
            //obtener las fotos
            let fotos=['','','','','','']
            fotos[0]=document.getElementById( 'img1' ).src;
            fotos[1]=document.getElementById( 'img2' ).src;
            fotos[2]=document.getElementById( 'img3' ).src;
            fotos[3]=document.getElementById( 'img4' ).src;
            fotos[4]=document.getElementById( 'img5' ).src;
            fotos[5]=document.getElementById( 'img6' ).src;
            //obtener y subir la ficha nueva (si existe lo pisa)
            if (this.archivo!=''){
                let InstFormData = new FormData();
                InstFormData.append('archivo' , this.archivo);
                InstFormData.append('contrato' , this.contrato);
                const response= await axios.post(process.env.VUE_APP_URL + '/api/v1/server/FileUp/', InstFormData , {headers : {'content-type': 'multipart/form-data'}});
                if (response.data=='ok'){
                    this.nombre_archivo = this.archivo.name;
                    this.rutaPDF = process.env.VUE_APP_URL + '/images/'+ this.contrato + '/' + this.archivo.name;
                }
            };
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                id: this.id_producto,
                contrato : this.contrato,
                user: this.user,
                tipo : this.tipo,
                codigo : this.sku,
                producto : this.producto,
                descripcion : this.descripcion,
                categoria : this.categoria,
                marca : this.marca,
                modelo : this.modelo,
                serie : this.serie,
                medida : this.medida,
                peso : this.peso,
                volumen : this.volumen,
                barra : this.barra,
                precio_oferta : this.precio_oferta,
                precio_detalle : this.precio_detalle,
                precio_mayor : this.precio_mayor,
                estado : this.estado,
                ficha: this.rutaPDF,
                archivo: this.nombre_archivo,
                bodega: this.bodega,
                critico: this.critico
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/product/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                //update de las fotos
                for (let index = 0; index < fotos.length; index++) {
                    let myFoto = fotos[index];
                    if(myFoto==this.imgDefault){ myFoto='' };
                    const par = {
                        contrato : this.contrato,
                        user: this.user,
                        id: index,
                        codigo: this.sku,
                        foto: myFoto,
                    };
                    const result = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/photo/',par,{headers});
                    console.log('resultado', result.data);                    
                };
                this.color_snack='success';
                this.mensaje='Producto actualizado con exito';
                this.snack=true
                await this.searchProductList();
                await this.clsInput();
            } else {
                this.color_snack='error';
                this.mensaje='No es posible actualizar el Producto';
                this.snack=true
            }
        } catch (error) {
            console.log(error)
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
    },
    deleteImage(key){
        switch (key) {
            case 1:
                document.getElementById( 'img1' ).src=this.imgDefault
            break;
            case 2:
                document.getElementById( 'img2' ).src=this.imgDefault
            break;
            case 3:
                document.getElementById( 'img3' ).src=this.imgDefault
            break;
            case 4:
                document.getElementById( 'img4' ).src=this.imgDefault
            break;
            case 5:
                document.getElementById( 'img5' ).src=this.imgDefault
            break;
            case 6:
                document.getElementById( 'img6' ).src=this.imgDefault
            break;
        }
    },
    onlyDecimal ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    openViewImage(key){
        this.d_image=true;
        this.generateImg=false;
        this.imgSrc='';
        this.viewImage(key);
    },
    viewImage(key){
        setTimeout(() => {
            switch (key) {
                case 1:
                    //document.getElementById( 'Img' ).src = document.getElementById( 'img1' ).src;
                    this.imgSrc = document.getElementById( 'img1' ).src;
                break;
                case 2:
                    this.imgSrc = document.getElementById( 'img2' ).src;
                break;
                case 3:
                    this.imgSrc = document.getElementById( 'img3' ).src;
                break;
                case 4:
                    this.imgSrc = document.getElementById( 'img4' ).src;
                break;
                case 5:
                    this.imgSrc = document.getElementById( 'img5' ).src;
                break;
                case 6:
                    this.imgSrc = document.getElementById( 'img6' ).src;
                break;
            };         
            this.generateImg=true;
        }, 2000);
    },
    closeViewImage(){
        //document.getElementById( 'Img' ).src ='';
        this.imgSrc='';
        this.d_image=false;
    },
    async fileUp(){
        try {
            this.loading=true;
            if(this.sku!='' && this.sku!=null){
                if (this.archivo!=''){
                    let InstFormData = new FormData();
                    InstFormData.append('archivo' , this.archivo);
                    InstFormData.append('contrato' , this.contrato);
                    const response= await axios.post(process.env.VUE_APP_URL + '/api/v1/server/FileUp/', InstFormData , {headers : {'content-type': 'multipart/form-data'}});
                    if (response.data=='ok'){
                        await this.saveImagen(this.archivo.name);
                    }
                    if (response.data=='no'){
                        this.color_snack='error';
                        this.mensaje='Archivo no Permitido';
                        this.snack=true
                    }
                    if (response.data=='error'){
                        this.color_snack='error';
                        this.mensaje='No es posible subir archivo';
                        this.snack=true
                    }
                } else {
                    this.color_snack='error';
                    this.mensaje='Seleccione archivo';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Seleccione Sku del producto';
                this.snack=true
            }
            this.loading=false;            
        } catch (error) {
          console.log(error)  
        }
    },
    async saveImagen(nameArchivo){
        const rutaArchivo = process.env.VUE_APP_URL + '/images/'+ this.contrato + '/' + nameArchivo;
        this.rutaPDF = rutaArchivo;
        const headers = {
            'Content-Type' : 'application/json',
            'Authorization' : 'Token ' + this.apikey
        };
        const params = {
            contrato : this.contrato,
            user: this.user,
            ruta: rutaArchivo,
            archivo: nameArchivo,
            codigo: this.sku
        };
        const response = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/ficha/',params,{headers});
        const datos = response.data;
        if(datos[0].existe=='si') {
            this.color_snack='success';
            this.mensaje='Ficha tecnica ok';
            this.snack=true
        } else {
            this.color_snack='error';
            this.mensaje='Ficha tecnica no grabada'
            this.snack=true
        }
    },
    async open_pdf(){
        if (this.rutaPDF!=null && this.rutaPDF!=''){
            this.d_pdf = true;
        }
    },
    async open_edit_marca(item){
        this.id_edit=0;
        this.edit_marca='';
        this.id_edit=item.id;
        this.edit_marca=item.marca;
        this.d_edit_marca=true;
    },
    async update_brand(){
        if(this.edit_marca!='' && this.edit_marca!=null){
            this.loading=true;
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    contrato : this.contrato,
                    user :  this.user,
                    id: this.id_edit,
                    marca: this.edit_marca.toUpperCase()
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/brands/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    let found = this.marcas.filter( res => parseInt(res.id) == parseInt(this.id_edit));
                    if(found.length!=0){
                        found[0].marca = this.edit_marca.toUpperCase()
                    }
                };
            } catch (error) {
                console.log(error)
            };
            this.loading=false;
        };
        this.d_edit_marca=false;
    },
    async open_edit_categoria(item){
        this.id_categoria=0;
        this.edit_categoria='';
        this.id_categoria=item.id;
        this.edit_categoria=item.categoria;
        this.d_edit_categoria=true;
    },
    async update_category(){
        if(this.edit_categoria!='' && this.edit_categoria!=null){
            this.loading=true;
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    contrato : this.contrato,
                    user :  this.user,
                    id: this.id_categoria,
                    categoria: this.edit_categoria.toUpperCase()
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/category/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    let found = this.categorias.filter( res => parseInt(res.id) == parseInt(this.id_categoria));
                    if(found.length!=0){
                        found[0].categoria = this.edit_categoria.toUpperCase()
                    }
                };
            } catch (error) {
                console.log(error)
            };
            this.loading=false;
        };
        this.d_edit_categoria=false;
    },

  }
}
</script>
